export default "__VITE_ASSET__BB8Ymict__"